import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { isArray } from '@/utils/validate'
import StrUtils from '@/utils/StrUtils'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { PrintUtils } from '@/utils/PrintUtils'
import {
  surrendered,
  postRemotingTracking,
  xhqUpdateBillInfo,
  xhqQueryCheckTheBLLog,
  xhqGetCfmAddress,
  xhqQueryAgentFeedbackCount,
  requestRelease,
  cancelRequestRelease,
  getGuaranteeStateInfo
} from '@/api/seaExport/seaCargoDoc'
import { updateTrackingEvent } from '@/api/trackingService'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import $store from '@/store'
import { queryIsInsured } from '@/api/external/insure'
import { loadSpecificBasicInfo } from '@/api/cache'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  CFM_BILL_STATE_NEW, CFM_BILL_STATE_RELEASE, CFM_BILL_STATE_UPDATE
} from '@/class/cargo/model/parameters/XhqBillCfmState'
import {
  CARGODOC_CFM_STATE_EXCEPTION,
  CARGODOC_CFM_STATE_WKS,
  CARGODOC_CFM_STATE_ZDD
} from '@/class/cargo/model/parameters/CargoDocCfmState'
import { sopTriggerHandler } from '@/api/booking/sopTrigger'
import { getDocumentTypeByExt } from '@/api/sysManage/baseConfig/docCategory'
import { cache } from '@/utils/cacheManager'
import { DOC_PAGE_SOURCE } from '@/class/cargo/model/parameters/SystemConstants'
import { getInitialDocHsCode } from './seaHsCodeMode'

export class TabHBLPM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this.$i18n = view.$i18n
    this.prompt1TitleWindow = null
    this.promptTitleWindow = null
    this._voyages = []
    this.vesselList = []
    this._allowEditingVessel = false
    this.editVesselVoyageMode = 2 // 船名编辑模式
    this.editVoyageMode = 2 // 航次
    this._lclslaveEnabled = false
    this.afrAddressWindow = null // 反恐地址维护
    this.isEditSingleCargoDoc = 0 // 是否允许修改被并单的数据  0不允许1.允许（不同步）2.允许（同步并单）
    this.originalPrintCheckSerialNo = false // 提单流水号打印验证
    this.lockHBLReleaseStateBeforeReleaseVerify = 0
    this.isCanEditQwc = false // 是否可编辑件毛体
    this.checkHistoryLabMap = {}
    this.checkHistoryTextMap = {}
    this.alertFlag = true
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode // 是否同步收发通代码到基本页签
    this.jionFlag = false // 是否有并单
    this.currentVessel = null // 当前船名航次
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.printParam5Type = [
      { label: '', data: '' },
      { label: 'SEABRIDGE FCL', data: 'DELIVERY ORDER FEE ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL NORMAL', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL INCLUDE CISF', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES AND CISF ON ACCOUNT OF CNEE' }
    ]
    this.view.$nextTick(() => {
      this.creationCompleteHandler()
    })
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  /**
   * init
   */
  async init() {
    this.originalPrintCheckSerialNo = Number(this.config.get('originalPrintCheckSerialNo')) === 1
    this.editVesselVoyageMode = Number(this.config.get('EditVesselVoyageMode'))
    this.lockHBLReleaseStateBeforeReleaseVerify = Number(this.config.get('LockHBLReleaseStateBeforeReleaseVerify'))
    this.editVoyageMode = Number(this.config.get('EditVoyageMode'))
    this.editInputVesselModel()
    this.isEditSingleCargoDoc = Number(this.config.get('SingleCargoDocEdit'))
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.view.maxChars = Number(this.config.get('SEHBLShipperConsigneNotifyMaxchars')) || 45
    this.view.warningCount = Number(this.config.get('SEHBLShipperConsigneNotifyWarningColor')) || 35
    this.view.OpenXHQDocumentCenter = !(this.config.get('OpenXHQDocumentCenter') === '0')
    this.view.ToExoSystemJYD = this.config.get('ToExoSystem') === 'JYD'
    this.view.PICtoXHQDocumentCenter = Number(this.config.get('PICtoXHQDocumentCenter'))
    this.view.IfXHQReleaseRequireHBLReleaseReview = Number(this.config.get('IfXHQReleaseRequireHBLReleaseReview'))
    // 从配置中读取英文品名最大字符数
    const maxChars = Number(this.config.get('SEHBLEnglishDescriptionOfGoodsMaxchars'))
    if (maxChars > 0) {
      this.view.englishNameMaxChars = maxChars
    }
    // 从配置中读取唛头最大字符数
    const maxChars2 = Number(this.config.get('SEHBLMarkMaxChars'))
    if (maxChars2 > 0) {
      this.view.markMaxChars = maxChars2
    }
    // 从配置中读取海运出口MBL英文品名标红字符数
    const maxColor = Number(this.config.get('SEHBLEnglishDescriptionOfGoodWarningColor'))
    if (maxColor > 0) {
      this.view.englishNameWarningCount = maxColor
    }
    // 从配置中读取海运出口MBL唛头标红字符数
    const maxColor2 = Number(this.config.get('SEHBLMarkWarningColor'))
    if (maxColor2 > 0) {
      this.view.markWarningCount = maxColor2
    }
    this.getCompanyIdData()
    await Promise.all([
      getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm).then(data => {
        this.shippingTermList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm).then(data => {
        this.paymentTermList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_OrderFormType).then(data => {
        this.orderFormTypeList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.blType === 3) {
            const blMode = this.view.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.view.blModeList.push(item)
            }
          }
        }
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
        this.packingList = data
      }),
      this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
    ])
  }
  getCompanyIdData() {
    if (this.job.uuid) {
      const cmp = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (cmp && cmp.mustInputScn) {
        this.job.editCftMode = true
      }
    }
  }
  creationCompleteHandler(evt) {
    this.initCheckHistoryMap()
    this.editInputVesselModel()
    this.lclslaveEnabledChanged()
  }
  initCheckHistoryMap() {
    // checkHistoryLabMap = {
    //   'shipperLine': view.shipperLineLabel,//收货人
    //   'consigneeLine': view.consigneeLineLabel,//发货人
    //   'notifyLine': view.notifyLineLabel,//通知人
    //   'agentPartyLine': view.agentPartyLineLabel,//代理信息
    //   'BLNumber': view.BLNumberLabel,//提单份数
    //   'packing': view.packingLabel,//包装
    //   'insideQuantity': view.insideQuantityLabel,//小件数
    //   'insidePacking': view.insidePackingLabel,//小件数包装类型
    //   'dispatchingPlace': view.dispatchingPlaceLabel,//(提单发货地)发货地
    //   'weight': view.weightLabel,//提单毛重
    //   'cubage': view.cubageLabel,//提单体积
    //   'loadingPort': view.loadingPortLabel,//(提单起运港)装货港
    //   'dischargingPort': view.dischargingPortLabel,//(提单卸货港)中转港
    //   'destinationPort': view.destinationPortLabel,//(提单交货地)目的港
    //   'cargoEnglishName': view.cargoEnglishNameLabel,//英文品名
    //   'mark': view.markLabel,//唛头
    //   'remarks': view.remarksLabel//备注
    // }
    // checkHistoryTextMap = {
    //   'shipperLine': view.txtshipperLine1,//收货人
    //   'consigneeLine': view.txtconsigneeLine1,//发货人
    //   'notifyLine': view.txtnotifyLine1,//通知人
    //   'agentPartyLine': view.agentPartyLineLabel,//代理信息
    //   'BLNumber': view.txtBLNumber,//提单份数
    //   'packing': view.txtPacking,//包装
    //   'insideQuantity': view.txtquantity,//小件数
    //   'insidePacking': view.txtInsidePacking,//小件数包装类型
    //   'dispatchingPlace': view.txtDispatchingPlace,//(提单发货地)发货地
    //   'weight': view.txtWeight,//提单毛重
    //   'cubage': view.txtCubage,//提单体积
    //   'loadingPort': view.txtLoadingPort,//(提单起运港)装货港
    //   'dischargingPort': view.txtDischargingPort,//(提单卸货港)中转港
    //   'destinationPort': view.txtDestinationPort,//(提单交货地)目的港
    //   'cargoEnglishName': view.txtCargoEnglishName,//英文品名
    //   'mark': view.txtMark,//唛头
    //   'remarks': view.txtremarks//备注
    // }
  }
  display() {
    this.checkCmbtypeHBLEnabled()
    this.lockBookingTab()
  }
  async changeJob() {
    const job = new SeaExportJob(this.job)
    const cargoDoc = await job.getSeaCargoDoc()
    await this.loadCargoDoc2Handler(cargoDoc)
    const jointSlavesHBL = await job.getJointSlavesHBL()
    this.loadJointSlaves2Handler(jointSlavesHBL)
    this.job.jointMasterHBL = await job.getJointMasterHBL()
    if (this.alertFlag && this.jionFlag) {
      this.alertFlag = false
      if (this.job.jointMasterHBL) {
        this.$message.info(this.view.$t('Message.ThisHblIsCombinedAndCannotBeEdited1') + '（' + this.job.jointMasterHBL.jobNo + '),' + this.view.$t('Message.hisHblIsCombinedAndCannotBeEdited2'))
      }
    }
    if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
      for (const key in this.view.specialCharCheck) {
        this.view.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
      }
    } else {
      for (const key in this.view.specialCharCheck) {
        this.view.specialCharCheck[key] = null
      }
    }
    if (this.view.OpenXHQDocumentCenter && this.form.uuid) {
      // 查询海外代理反馈记录条数,大于0说明有回传
      xhqQueryAgentFeedbackCount({ cargoDocUuid: this.form.uuid }).then(res => {
        if (res.data > 0) {
          this.view.showXhqOverseasAgentFeedbackLink = true
        } else {
          this.view.showXhqOverseasAgentFeedbackLink = false
        }
      })
    }
  }
  async fillView() {
    if (this.view.isEdit) {
      this.currentVessel = this.vesselList.filter(p => p.englishName === this.job.vessel)[0]
      await this.getVoyageByVessel()
    }
    this.editInputVesselModel()
    this.getCompanyIdData()
    // this.refushLoadType()
    this.refreshQuantitySum()
    this.lclslaveEnabledChanged()
    this.resetColor()
    this.showCarrierAgentScac()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      this.loadCheckDocs()
    }
    if (!this.form.freightTermHBL) {
      const shippingTerm = this.shippingTermList.find(p => p.code === this.job.freightTermHBL)
      if (shippingTerm) {
        this.form.freightTermHBL = shippingTerm.name
      }
    }
    await this.isEditTypeHbl()
  }
  fillModel() {
    if (!this.form.uuid) {
      this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_DHD.code
    }
    this.view.$store.dispatch('log/addLog', {
      type: 'info',
      msg: 'hbl:' + this.form,
      url: window.location.href
    })
    // 提单发货地
    this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 提单目的地
    this.form.destinationPlace = this.form.destinationPlace.toUpperCase()
    const billOfLadingSynMode = parseInt(this.config.get('BillOfLadingSynMode'))
    // 包装
    if (this.view.isEdit && billOfLadingSynMode === 2) {
      this.job.packing = this.form.packing
    }

    this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)

    // 提单份数
    this.form.blNumber = this.form.blNumber.toUpperCase()

    // 唛头
    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // this.form.mark = this.form.mark.toUpperCase()
    this.form.state = this.form.state || 1
    this.form.container = this.form.container.toUpperCase()
    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()
    this.changeAfrAddress()
    // 处理特殊字符
    JobUtils.handlingSpecialCharactersForCargoDoc(this.form)
    CargoDocUtil.syncCargoDocSftToJob(this.job, this.form)
  }
  changeBillOfLadingSynJob(needUpdateUsage = false) {
    if (!this.view.isEdit) return
    CargoDocUtil.changeBillOfLadingSynJob(this.job, this.form, needUpdateUsage)
  }
  calculateChargeWeight() {
    CargoDocUtil.calculateSEChargeWeight(this.form)
  }
  validateForm() {
    if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      const regexp = /^\W*to\W*-?\W*order\W*$/i
      if (regexp.test(this.form.consigneeLine1)) {
        throw new TabError(this.view.$t('Message.ToOrederBlCannotBeTelexReleased'), 'tabHBL')
      }
    }
  }
  async executeTask() {
    // HBL 放单
    console.log('executeTask')
    DocCommon.HBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.HBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.HBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.HBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.HBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.HBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.HBL_History.shipperCode = this.form.shipperCode
    DocCommon.HBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.HBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.HBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.HBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.HBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.HBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.HBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.HBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.HBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.HBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.HBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.HBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.HBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.HBL_History.notifyCode = this.form.notifyCode
    DocCommon.HBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.HBL_History.mark = this.form.mark
    // 委托单位 收发通必填选中时  不保存收发通信息
    if (!this.job.editCftMode) {
      // 保存客户发运信息
      this.view.addrPM.isHBL = true
      this.view.addrPM.copyAddrType = 'HBL'
      this.view.addrPM.job = this.job
      this.view.addrPM.shipperCodeField = ''
      this.view.addrPM.shipperField = 'shipperLine'
      this.view.addrPM.consigneeCodeField = ''
      this.view.addrPM.consigneeField = 'consigneeLine'
      this.view.addrPM.notifyCodeField = ''
      this.view.addrPM.notifyField = 'notifyLine'
      if (parseInt(this.config.get('syncMailingAddress')) === 1) {
        await this.view.addrPM.saveCheck()
      }
    }
    // HBL 放单
    console.log('lockHBLReleaseStateBeforeReleaseVerify', this.lockHBLReleaseStateBeforeReleaseVerify)
  }
  /**
   * 打印hbl
   */
  printHblPost(event) {
    if (event && event.action === 'print') {
      updateTrackingEvent({ jobUuid: this.job.uuid, eventCode: 'print_hbl' }).then(async res => {
        this.job.trackingInfo = ''
        const jobClass = new SeaExportJob(this.job)
        await jobClass.getTrackingInfo()
      }).finally(() => {
      })
    }
  }
  /**
   * V2打印反馈
   */
  v2CheckCallbackFun(printed, template, entity, params) {
    if (printed) {
      this.updateTrackingEvent()
    }
  }
  async updateTrackingEvent(result = null) {
    this.job.trackingInfo = ''
    const jobClass = new SeaExportJob(this.job)
    await jobClass.getTrackingInfo()
  }
  print_callback(event) {
    const action = event && event.action ? String(event.action) : ''
    // Debug: trace why /seaCargoDoc/surrendered isn't triggered
    // eslint-disable-next-line no-console
    console.log(`[HBLPM][print_callback] action=${action} category=${(this.view && this.view.templateSelectorDialog && this.view.templateSelectorDialog.category) || ''} cargoDocUuid=${(this.form && this.form.uuid) || ''}`)
    if (action === 'print') {
      // CARGO-39566 正本打印/电放打印，不影响 “提单确认状态”状态 （可做平台优化）
      // this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code // 已放单
      this.form.state = 2
      this.form.releaseState = ReleaseState.ONSINGLERELEASE.code
      // eslint-disable-next-line no-console
      console.log(`[HBLPM][print_callback] call surrendered: uuid=${this.form.uuid} state=${this.form.state} releaseState=${this.form.releaseState} cfmState=${this.form.cfmState}`)
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state, releaseState: this.form.releaseState }).then(res => {
        if (res.data) {
          Object.assign(this.form, res.data)
          this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
          this.loadJointSlaves2Handler()
        }
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(`[HBLPM][print_callback] surrendered error: ${e && e.message ? e.message : String(e)}`)
      })
      // startCreateFile()
      this.lockBookingTab()
      this.postRemotingTracking('SE-IssueHBL')
    }
  }
  /**
   * 锁定业务页签
   */
  lockBookingTab() {
    this.view.job.printHblZbLock = this.form.state === 2 && Number(this.config.get('HBLPrintLockTab')) === 1
  }
  async v2CheckCallbackFun2(printed, template, entity, params) {
    this.postRemotingTracking('SE-IssueHBL')
    // eslint-disable-next-line no-console
    console.log(`[HBLPM][v2CheckCallbackFun2] printed=${printed} eventAction=${(params && params.event && params.event.action) || ''} cargoDocUuid=${(this.form && this.form.uuid) || ''}`)
    // 提单状态改为已放单
    if (printed && params.event && params.event.action === PrintUtils.PRINT) {
      // CARGO-39566 正本打印/电放打印，不影响 “提单确认状态”状态 （可做平台优化）
      // this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
      this.form.state = 2
      this.form.releaseState = ReleaseState.ONSINGLERELEASE.code
      // eslint-disable-next-line no-console
      console.log(`[HBLPM][v2CheckCallbackFun2] call surrendered: uuid=${this.form.uuid} state=${this.form.state} releaseState=${this.form.releaseState} cfmState=${this.form.cfmState}`)
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state, releaseState: this.form.releaseState }).then(async res => {
        if (res.data) {
          Object.assign(this.form, res.data)
          // 修改提单签发状态
          this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
        }
        this.loadJointSlaves2Handler()
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(`[HBLPM][v2CheckCallbackFun2] surrendered error: ${e && e.message ? e.message : String(e)}`)
      }).finally(() => {
      })
    } else {
      this.job.cargoDoc = ''
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      this.loadJointSlaves2Handler()
    }
  }
  postRemotingTracking(eventCode) {
    postRemotingTracking({ jobUuid: this.job.uuid, eventCode: eventCode }).then(res => {
    }).finally(() => {
    })
  }
  async loadCargoDoc2Handler(cargoDocList) {
    this.form = null
    if (cargoDocList.length > 0) {
      for (const hCargoDoc of cargoDocList) {
        if (hCargoDoc.docType === CargoDocConsts.HBL) {
          this.form = hCargoDoc
        }
        if (hCargoDoc.docType === CargoDocConsts.HBL2 && this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
          this.view.cmbtypeHBLDisabled = true
        }
      }
    }
    if (!this.form) {
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      await SeaCargoDoc.copyInfoFromSeaExportJob(this.job, this.form)
      this.form.docType = CargoDocConsts.HBL
      this.form.jobUuid = this.job.uuid
      const seHsCodeMode = this.config ? Number(this.config.get('SEHSCodeMode')) : 0
      this.form.hsCode = getInitialDocHsCode({ jobHsCode: this.job.hsCode, seHsCodeMode })
      console.log(`[HS_SYNC][HBLPM] init new HBL doc mode=${seHsCodeMode} job.hsCode="${this.job.hsCode || ''}" form.hsCode="${this.form.hsCode || ''}"`)
      cargoDocList.push(this.form)
    } else {
      console.log(`[HS_SYNC][HBLPM] load existing HBL doc mode=${this.config ? Number(this.config.get('SEHSCodeMode')) : 0} job.hsCode="${this.job.hsCode || ''}" form.hsCode="${this.form.hsCode || ''}"`)
      if (this.form.pageSource === DOC_PAGE_SOURCE) {
        // 暂时不用 copyInfoFromSeaExportJob
        await SeaCargoDoc.copyInfoFromJobPort(this.job, this.form)
      }
      const afrAddress = await new SeaCargoDoc(this.form).getAfrAddress()
      this.loadAfrAddressHandler(afrAddress[0])

      // CARGO-40140 添加接口调用获取保函状态
      await this.updateGuaranteeStateInfo()
    }
    const freightCharges = await new SeaCargoDoc(this.form).getFreightCharges()
    this.loadFreightChargesHandler(freightCharges)
    // 若基本页签取消直单后勾选HBL 则不将业务编号带入
    if (this.view.isEdit && !this.form.hblNbr2 && !this.form.isMblOnly) {
      this.form.hblNbr2 = this.job.jobNo
    }
    this.cmbissuerHBL_changeHandler()
    this.editingChanged()
    this.checkReleaseTypeState()
    this.docCfmStateChanged()
    this.controlQwcRoleEdit()
  }
  async updateGuaranteeStateInfo() {
    if (this.form.uuid) {
      const guaranteeStateInfo = await getGuaranteeStateInfo({ cargoDocUuid: this.form.uuid }).then(res => res.data)
      // 长期保函状态：0-无保函，1-生效中，2-已生效
      // 单票保函状态：0-未上传，1-已上传，2-无需上传
      if (guaranteeStateInfo) {
        this.view.longTermGuaranteeState = guaranteeStateInfo.longTermGuaranteeState
        this.view.singleTicketGuaranteeState = guaranteeStateInfo.singleTicketGuaranteeState
        this.view.guaranteeConfigEnable = guaranteeStateInfo.configEnable
        this.form.longTermGuaranteeState = guaranteeStateInfo.longTermGuaranteeState
        this.form.singleTicketGuaranteeState = guaranteeStateInfo.singleTicketGuaranteeState
        this.form.guaranteeConfigEnable = guaranteeStateInfo.configEnable
      }
    }
  }
  /**
   * 加载并单
   */
  loadJointSlaves2Handler(result = null) {
    this.docCfmStateChanged()
    this.checkCmbtypeHBLEnabled()
    this.printStateChange()
    this.checkUnlockBtnState()
  }
  /**
   * check doc tyoe enable
   */
  checkCmbtypeHBLEnabled() {
    if (this.job.jointSlavesHBL && this.job.jointSlavesHBL.length > 0) {
      this.view.cmbtypeHBLDisabled = true
    } else {
      this.view.cmbtypeHBLDisabled = this.view.readonly
    }
    this.isEditTypeHbl()
  }
  async isEditTypeHbl() {
    if (!this.job.seaCargoDoc || this.job.seaCargoDoc.length <= 0) {
      await new SeaExportJob(this.job).getSeaCargoDoc()
    }
    const cargoDocList = this.job.seaCargoDoc
    if (cargoDocList && cargoDocList.length > 0) {
      if (Number(this.job.typeHBL) === 2) {
        for (const doc of cargoDocList) {
          if (doc.docType === 'HBL2' && !doc.deleted) {
            this.view.cmbtypeHBLDisabled = true
            break
          }
        }
      }
    }
  }
  /**
   * afr
   */
  loadAfrAddressHandler(afrAddress) {
    this.view.chkConsolidationClosed = afrAddress && afrAddress.consolidationClosed > 0
  }
  /**
   * 运费
   */
  loadFreightChargesHandler(freightCharges) {
    this.view.rowData = freightCharges
  }
  /**
   * 获取最近修改的对单记录
   */
  async loadCheckDocs() {
    const checkDocHistories = await CheckCargoDocHistory.queryDocHistoryByTime(this.form.uuid)
    this.queryTopCheckDocHistoriesHandler(checkDocHistories)
  }
  queryTopCheckDocHistoriesHandler(checkDocHistories) {
    this.comparedCargoDocIsModified(checkDocHistories)
  }
  /**
   * 对单后把有修改的内容显示红色
   */
  comparedCargoDocIsModified(checkDocHistories) {
    if (checkDocHistories && checkDocHistories.length > 0) {
      const variableCss = this.view.variableCss
      // 获取对单记录的第一条记录，根据是否有标识字段判断是否对单时修改了字段,有字段修改的情况去改变字段颜色
      const firstCheckDaoHistory = checkDocHistories[0]
      if (firstCheckDaoHistory.fieldName !== 'noChange') {
        for (const checkDocHistory of checkDocHistories) {
          const fieldName = checkDocHistory.fieldName
          if (variableCss.hasOwnProperty(fieldName)) {
            if (fieldName === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
              continue
            } else if (fieldName === 'mark' && this.form.mark.length >= 22) {
              continue
            }
            this.checkHistoryTextMapChanged(checkDocHistory, checkDocHistories)
          }
        }
      }
    }
  }
  /**
   * 对单内容
   */
  checkHistoryTextMapChanged(checkDocHistory, checkDocHistories) {
    switch (checkDocHistory.fieldName) {
      case 'shipperLine':
        this.checkHistoryByShipperConsigneeNotifyLine('shipperLineOld', 'shipperLine', checkDocHistory, checkDocHistories)
        break
      case 'consigneeLine':
        this.checkHistoryByShipperConsigneeNotifyLine('consigneeLineOld', 'consigneeLine', checkDocHistory, checkDocHistories)
        break
      case 'notifyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('notifyLineOld', 'notifyLine', checkDocHistory, checkDocHistories)
        break
      case 'agentPartyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('agentPartyLineOld', 'agentPartyLine', checkDocHistory, checkDocHistories)
        break
      default:
        this.view.variableCss[checkDocHistory.fieldName] = 'red'
        break
    }
  }
  /**
   * 检查收发通知人是否发生变化
   */
  checkHistoryByShipperConsigneeNotifyLine(oldField, textField, checkDocHistory, checkDocHistories) {
    const line = checkDocHistory.fieldValue
    const oldLine = this.getDocHistoryShipperConsigneeNotify(oldField, checkDocHistories)
    const lines = line.split('|')
    const oldLines = oldLine.split('|')
    for (let i = 0; i < lines.length; ++i) {
      const index = i + 1
      const line2 = lines[i].replace('\r\n', '')
      const lineOld2 = oldLines[i].replace('\r\n', '')
      if (line2 !== lineOld2) {
        this.view.variableCss[textField] = 'red'
        this.view.variableCss[textField + index] = 'red'
      }
    }
  }
  /**
   * 获取上一个版本收发通历史的数据
   */
  getDocHistoryShipperConsigneeNotify(fieldName, checkDocHistories) {
    for (let i = 0; i < checkDocHistories.length; i++) {
      if (checkDocHistories[i].fieldName === fieldName) {
        return checkDocHistories[i].fieldValue
      }
    }
    return ''
  }
  /**
   * 重置对单颜色
   */
  resetColor() {
    for (const key in this.view.variableCss) {
      if (key === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
        continue
      } else if (key === 'mark' && this.form.mark.length >= 22) {
        continue
      }
      this.view.variableCss[key] = ''
    }
  }
  /**
   * 提单种类修改
   */
  cmbissuerHBL_changeHandler(data) {
    if (!data) {
      if (this.orderFormTypeList && this.orderFormTypeList.length > 0) {
        data = this.orderFormTypeList.find(p => p.code === this.form.issuerBL)
        if (!data) {
          data = this.orderFormTypeList[0]
          this.form.issuerBL = data.code
        }
      }
    } else {
      this.form.issuerBL = data.code
      if (data.code === 'TH') {
        this.view.hblNoDisabled = false
      } else {
        this.view.hblNoDisabled = this.config.get('SEAllowEditHBLNo') !== '1'
      }
    }
    this.printStateChange()
  }
  validate6Line(s) {
    return true
  }
  /**
   * 邀请对单
   */
  inviteConfirmBL() {
    // CfmCargoDocPoPupUtils.getCfmBillAddress(view.cargoDoc, view, getCfmBillAddressHandler)
  }
  reloadCargoDocHandler(e = null) {
    this.changeJob()
    this.fillView()
  }
  /**
   * 确认对单
   */
  async confirmBL() {
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
      this.view.$message.info(this.view.$t('Message.BlIsConfirmed'))
      return
    }
    this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code
    if (String(cache.config.get('ToExoSystem')) === 'TP') {
      await new SeaCargoDoc(this.form).affirmSeaCargoDoc()
    } else {
      await new SeaCargoDoc(this.form).save()
    }
    const newDoc = await SeaCargoDoc.getSeaCargoDoc(this.form.uuid)
    if (newDoc) {
      Object.assign(this.form, newDoc)
    }
    this.confirmResultHandler()
    CargoDocUtil.syncCargoDocSftToJob(this.job, this.form)
  }
  /**
   * 信号旗确认对单
   */
  async xhqConfirmBL() {
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
      this.view.$message.info(this.view.$t('Message.BlIsConfirmed'))
      return
    }
    if (this.form.cfmState >= CargoDocCfmState.CARGODOC_CFM_STATE_EXCEPTION.code && this.form.customerSelfRelease === 1) {
      this.form.releaseState = ReleaseState.ONSINGLERELEASE.code
      this.form.bliStatus = 12
    }
    this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code
    await new SeaCargoDoc(this.form).save()
    const newDoc = await SeaCargoDoc.getSeaCargoDoc(this.form.uuid)
    if (newDoc) {
      Object.assign(this.form, newDoc)
    }
    this.confirmResultHandler()
    // CARGO-39946 信号旗确认对单后，触发sop
    sopTriggerHandler({ uuid: this.job.uuid })
  }
  confirmResultHandler() {
    this.docCfmStateChanged()
  }
  /**
   * reset 收发通地址
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }
  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data) {
    this.form.shipperId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      this.applyShipperManifestAddress(data)
    } else {
      this.onClear(1)
    }
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'shipper', 1)
  }
  applyShipperManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.shipperCode = company.englishName
      this.form.shipperLine1 = manifestaddress.addressLine1
      this.form.shipperLine2 = manifestaddress.addressLine2
      this.form.shipperLine3 = manifestaddress.addressLine3
      this.form.shipperLine4 = manifestaddress.addressLine4
      this.form.shipperLine5 = manifestaddress.addressLine5
      this.form.shipperLine6 = manifestaddress.addressLine6
      this.form.shipperLine7 = manifestaddress.addressLine7
    } else {
      this.form.shipperCode = ''
      this.form.shipperLine1 = ''
      this.form.shipperLine2 = ''
      this.form.shipperLine3 = ''
      this.form.shipperLine4 = ''
      this.form.shipperLine5 = ''
      this.form.shipperLine6 = ''
      this.form.shipperLine7 = ''
    }
  }
  /**
   * 收货人选择
   */
  async consigneeAutoCompleteChange(data) {
    this.form.consigneeId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      this.applyConsigneeManifestAddress(data)
    } else {
      this.onClear(2)
    }
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
  }
  applyConsigneeManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.consigneeCode = company.englishName
      this.form.consigneeLine1 = manifestaddress.addressLine1
      this.form.consigneeLine2 = manifestaddress.addressLine2
      this.form.consigneeLine3 = manifestaddress.addressLine3
      this.form.consigneeLine4 = manifestaddress.addressLine4
      this.form.consigneeLine5 = manifestaddress.addressLine5
      this.form.consigneeLine6 = manifestaddress.addressLine6
      this.form.consigneeLine7 = manifestaddress.addressLine7
    } else {
      this.form.consigneeCode = ''
      this.form.consigneeLine1 = ''
      this.form.consigneeLine2 = ''
      this.form.consigneeLine3 = ''
      this.form.consigneeLine4 = ''
      this.form.consigneeLine5 = ''
      this.form.consigneeLine6 = ''
      this.form.consigneeLine7 = ''
    }
  }
  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data) {
    this.form.notifyId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      this.applyNotifyManifestAddress(data)
    } else {
      this.onClear(3)
    }
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
  }
  applyNotifyManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.notifyCode = company.englishName
      this.form.notifyLine1 = manifestaddress.addressLine1
      this.form.notifyLine2 = manifestaddress.addressLine2
      this.form.notifyLine3 = manifestaddress.addressLine3
      this.form.notifyLine4 = manifestaddress.addressLine4
      this.form.notifyLine5 = manifestaddress.addressLine5
      this.form.notifyLine6 = manifestaddress.addressLine6
      this.form.notifyLine7 = manifestaddress.addressLine7
    } else {
      this.form.notifyCode = ''
      this.form.notifyLine1 = ''
      this.form.notifyLine2 = ''
      this.form.notifyLine3 = ''
      this.form.notifyLine4 = ''
      this.form.notifyLine5 = ''
      this.form.notifyLine6 = ''
      this.form.notifyLine7 = ''
    }
  }
  /**
   * 抄录上次
   */
  onCopy1() {
    this.form.cargoEnglishName = DocCommon.HBL_History.englishCargoName
    this.form.mark = DocCommon.HBL_History.mark
  }
  selectionItemHandler(rows) {
    const selectedHBL = isArray(rows) ? rows[0] : rows
    if (selectedHBL) {
      this.form.shipperCode = selectedHBL.shipperCode
      this.form.shipperLine1 = selectedHBL.shipperLine1
      this.form.shipperLine2 = selectedHBL.shipperLine2
      this.form.shipperLine3 = selectedHBL.shipperLine3
      this.form.shipperLine4 = selectedHBL.shipperLine4
      this.form.shipperLine5 = selectedHBL.shipperLine5
      this.form.shipperLine6 = selectedHBL.shipperLine6
      this.form.consigneeCode = selectedHBL.consigneeCode
      this.form.consigneeLine1 = selectedHBL.consigneeLine1
      this.form.consigneeLine2 = selectedHBL.consigneeLine2
      this.form.consigneeLine3 = selectedHBL.consigneeLine3
      this.form.consigneeLine4 = selectedHBL.consigneeLine4
      this.form.consigneeLine5 = selectedHBL.consigneeLine5
      this.form.consigneeLine6 = selectedHBL.consigneeLine6
      this.form.notifyCode = selectedHBL.notifyCode
      this.form.notifyLine1 = selectedHBL.notifyLine1
      this.form.notifyLine2 = selectedHBL.notifyLine2
      this.form.notifyLine3 = selectedHBL.notifyLine3
      this.form.notifyLine4 = selectedHBL.notifyLine4
      this.form.notifyLine5 = selectedHBL.notifyLine5
      this.form.notifyLine6 = selectedHBL.notifyLine6
      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
      // LogStores.sendFunctionClickLogStoresByLabel('海运出口-HBL-单号抄录-收发通选择')
    }
  }
  /**
   * 抄录MBL
   */
  onCopyMBL() {
    let mdoc = null
    const seaCargoDoc = this.job.seaCargoDoc
    if (seaCargoDoc) {
      mdoc = seaCargoDoc.find(p => p.docType === 'MBL')
    }
    if (mdoc) {
      this.form.cargoEnglishName = mdoc.cargoEnglishName
      this.form.mark = mdoc.mark
    }
  }
  /**
   * 抄录收货人
   */
  onCopy_consignee() {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }
  /**
   * 复制主单收货人
   */
  async onCopy_agentParty() {
    const mdoc = await new SeaExportJob(this.job).getMainMbl()
    if (mdoc) {
      this.form.agentPartyLine1 = mdoc.consigneeLine1
      this.form.agentPartyLine2 = mdoc.consigneeLine2
      this.form.agentPartyLine3 = mdoc.consigneeLine3
      this.form.agentPartyLine4 = mdoc.consigneeLine4
      this.form.agentPartyLine5 = mdoc.consigneeLine5
      this.form.agentPartyLine6 = mdoc.consigneeLine6
      this.form.agentPartyLine7 = mdoc.consigneeLine7
    }
  }
  /**
   * 取指定货代理信息
   */
  onCopy_designationAgent() {
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.designationAgent)
    if (cpy) {
      new Company(cpy).getOverseaAgentDetail().then(data => {
        this.loadDestinationAgentHandler(data)
      })
    }
  }
  loadDestinationAgentHandler(overseaAgentDetail) {
    if (overseaAgentDetail) {
      this.form.agentPartyLine1 = overseaAgentDetail.blAddress
      this.form.agentPartyLine2 = overseaAgentDetail.blAddressLine2
      this.form.agentPartyLine3 = overseaAgentDetail.blAddressLine3
      this.form.agentPartyLine4 = overseaAgentDetail.blAddressLine4
      this.form.agentPartyLine5 = overseaAgentDetail.blAddressLine5
      this.form.agentPartyLine6 = overseaAgentDetail.blAddressLine6
      this.form.agentPartyLine7 = overseaAgentDetail.blAddressLine7
    }
  }
  /**
   * 锁定按钮处理
   */
  onSubmitStateEvent(event) {
    this.view.job.printHblZbLock = false
    surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: 1, releaseState: ReleaseState.SINGLERELEASE.code }).then(res => {
      if (res.data) {
        Object.assign(this.form, res.data)
        this.loadJointSlaves2Handler()
        if (this.view.isEdit) {
          this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
        }
        this.lockBookingTab()
      }
    })
  }
  /**
   * 解锁
   */
  unLockCargoDocHandler(e) {
    // loadJointSlaves2Handler()
  }
  /**
   * 投保
   */
  async toInsure() {
    console.log('currentOfficeId---------------', this.view.$store.getters.currentOfficeId)
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: this.form.uuid,
      billno: this.form.hblNbr2,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.context.config.get('isPlatformInsurance')) === 3) {
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: $store.getters.currentOfficeId,
    //     docUuid: this.form.uuid,
    //     billno: this.form.hblNbr2,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel('HBL-' + this.view.$t('SeaExport.Insure'))
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   if (this.config.get('isPlatformInsurance') === '1') {
    //     queryIsInsured(this.job.uuid, this.form.uuid).then(result => {
    //       if (result.data) {
    //         this.view.$message.warning(this.view.$t('SeaExport.ThisSuccessfullyInsuredRepeatedAllowed'))
    //         return
    //       } else {
    //         this.view.$router.push({ name: 'PolicyDetail', query: { 'jobUuid': this.job.uuid, 'type': 'HBL', 'viewSource': 'cargo', 'officeId': $store.getters.currentOfficeId }})
    //       }
    //     })
    //   } else {
    //     let hbl = null
    //     for (const doc of this.job.seaCargoDoc) {
    //       if (doc.docType === CargoDocConsts.HBL) {
    //         hbl = doc
    //         break
    //       }
    //     }
    //     // 因装箱 组装了 containerUsage与container的 循环依赖关系,重新copy job
    //     const jobCopy = { ... this.job }
    //     if (Object.prototype.hasOwnProperty.call(jobCopy, 'containerUsages')) {
    //       for (const usage of jobCopy.containerUsages) {
    //         delete usage.container
    //       }
    //     }
    //     SeaCargoDoc.toInsure(this.user.tenantName, hbl, jobCopy, this.context.office).then(data => {
    //       this.insureSuccessHandler(data)
    //     })
    //   }
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
  * 投保成功
  */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }
  /**
   * 提单种类更改处理
   */
  cmbtypeHBLChangeHandler(value) {
    const job = this.job
    const hbl2Types = [BillType.SPLIT_BILL_TYPE.code, BillType.MERGE_BILL_TYPE.code]
    if (hbl2Types.includes(job.typeHBL) && hbl2Types.includes(value) && job.typeHBL !== value) {
      this.view.$emit('resetTab', 'tabHBL2')
    }
    if (hbl2Types.includes(job.typeHBL) && job.typeHBL !== value) {
      const cargoDocArr = this.job.seaCargoDoc
      for (let i = cargoDocArr.length - 1; i >= 0; --i) {
        const item = cargoDocArr[i]
        if (item.docType === CargoDocConsts.HBL2) {
          item.deleted = true
          this.addCargoDocToModifiedSet(item)
          cargoDocArr.splice(i, 1)
        }
      }
    }
    job.typeHBL = value
  }
  // 添加cargoDoc到被修改的集合中
  addCargoDocToModifiedSet(item) {
    const modifiedData = this.context.modifiedData
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    const oldItem = modifiedData.seaCargoDoc.find(p => p === item)
    if (oldItem) {
      Object.assign(oldItem, item)
    } else {
      modifiedData.seaCargoDoc.push(item)
    }
  }
  /**
   * 提单方式更改处理
   */
  cmbreleaseTypeMBL_changeHandler(val) {
    if (Number(val) === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
  }
  /**
   * 船名航次选择
   */
  async onVesselSelectionChange(data) {
    await JobUtils.vesselOrVoyageChange(this.job, 'vessel', data.value, this)
    this.currentVessel = data
    this.job.vessel = data.value
    this.getVoyageByVessel()
    if (data.value && data.uuid) {
      this.getVesselCarrier()
    }
  }
  /**
   * 获取船舶呼号code
   */
  async getVesselCarrier() {
    const vessel = new Vessel(this.currentVessel)
    const vesselCarriers = await vessel.getVesselCarriers()
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        this.job.vesselCode = carrier.ediCode
        break
      }
    }
  }
  async getVoyageByVessel() {
    if (this.currentVessel && this.currentVessel.vesselId) {
      this._voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
    } else {
      this._voyages = []
    }
  }
  txtVoyageFocusInHandler() {
    let value = 'V.'
    if (this.job.voyageFlight) {
      value = this.job.voyageFlight
      this.job.voyageFlight = ''
    }
    this.view.$nextTick(async() => {
      this.job.voyageFlight = value
      const elSelect = this.view.$refs.voyageFlight.$refs.advanceSelectRef
      const innerInput = elSelect.$children[0].$refs.input
      innerInput.value = this.job.voyageFlight
    })
  }
  async onVoyagaFlightChange(data) {
    const job = this.job
    job.voyageFlight = data.value
    if (job.bookingTerm === 'SB' && job.destinationPortCode && job.destinationPortCode.length && job.carrierId) {
      if (job.vessel && job.voyageFlight.length > 2) {
        const ediCode = await Vessel.getEDICode(job.vessel, job.voyageFlight, job.destinationPortCode, job.carrierId)
        if (ediCode) {
          job.vesselCode = ediCode
        }
      }
    }
  }
  /**
   * HBL付款方式
   */
  paymentSelectHblChange(data) {
    this.paymentTermHBL_Change(data.value)
  }
  /**
   * HBL付款方式
   */
  paymentTermHBL_Change(value) {
    this.job.paymentTermHBL = value
    if (value === 'PP') {
      this.form.paymentPlaceHBL = this.form.loadingPort
    } else {
      this.form.paymentPlaceHBL = this.form.destinationPort
    }
  }
  /**
   * 包装
   */
  packing_Change(data) {
    this.form.packing = data.value
    this.form.packingName = data.name
    this.refreshQuantitySum()
  }
  /**
   * 件数
   */
  quantity_Change() {
    this.refreshQuantitySum()
    this.changeBillOfLadingSynJob(true)
  }
  /**
   * 打印状态控制
   */
  printStateChange() {
    this.view.btnPrintDisabled = true
    if (this.view.isEdit) {
      return
    }
    if (!this.form) {
      return
    }
    if (this.job.joinFlagHBL && this.job.jointMasterHBLUuid) {
      return
    }
    // 是否异地放单 ,如果是TRUE，正本打印、电放按钮无法打印
    if (this.form.oversea && this.form.releaseType === 1) {
      return
    }
    if (this.form.releaseType === 1) {
      if (this.view.$checkPermission(['button_printDoc'])) {
        if (this.form.state === 1) {
          this.view.btnPrintDisabled = false
        }
      }
    } else if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      // 有权限才行
      if (this.view.$checkPermission(['button_HBL_surrender'])) {
        this.view.btnPrintDisabled = false
      }
    } else {
      this.view.btnPrintDisabled = false
    }
    if (this.form.issuerBL === 'TH') {
      this.view.btnPrintDisabled = true
    }
    if (this.job.shutOut && !this.view.btnPrintDisabled) {
      this.view.btnPrintDisabled = true
    }
  }
  /**
   * 件数大小写合计
   */
  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }
  /**
   * 分单签发日期修改
   */
  txtsignDateHBLChangeHandler(event) {
    // view.cargoDoc.signDateBL = view.txtsignDateHBL.selectedDate
  }
  // /**
  //  * 装箱信息显示
  //  */
  // chargeContainer(event = null) {
  //   if (this.job.containerLoadType === 'BB') {
  //     this.form.container = SeaExportUtils.getContainerDesc(this.job, this.form.printParam3)
  //   }
  // }
  /**
   * 是否有解锁权限
   */
  checkUnlockBtnState() {
    // var user: User = Session.getInstance().user
    // view.btnSubmit.enabled = (view.cargoDoc && view.cargoDoc.state == 2 && user.hasUnlockPrivilege(PrivilegeShape.M_HBL))
  }
  /**
   * bug 996:如果HBL是已送出状态，则不允许更改“提单方式”
   */
  checkReleaseTypeState() {
    // if (!view.isEditing) return
    // var bool = true
    // for each(var f: File in view.job.file)
    // {
    //   if (f.fileType == FileType.HBL_TYPE.code.toString() && f.state == 1) {
    //     bool = false
    //     break
    //   }
    // }
    // view.cmbreleaseTypeHBL.enabled = bool
  }
  showCarrierAgentScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  docCfmStateChanged() {
    const isZh = this.view.$i18n.locale === 'zh'
    const cfmState = CargoDocCfmState.getCargoDocCfmStateByCode(this.form.cfmState)
    if (cfmState) {
      this.view.lblCfrState = isZh ? cfmState.chineseName : cfmState.englishName
    }
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
  }
  changeAfrAddress() {
    let afrAddress = null
    if (!this.form.afrAddress && this.view.chkConsolidationClosed) {
      afrAddress = new AfrAddress()
      afrAddress.state = 0
      afrAddress.docType = CargoDocConsts.AFR
      afrAddress.cargoDocUuid = this.form.uuid
      this.form.afrAddress.push(afrAddress)
    } else {
      afrAddress = this.form.afrAddress[0]
    }
    if (afrAddress) {
      afrAddress.consolidationClosed = this.view.chkConsolidationClosed ? 1 : 0
    }
  }
  /**
   * 开始创建File
   */
  startCreateFile() {
    // if (view.cargoDoc == null)
    //   return
    // File.queryFilesCount({ 'jobNo': view.cargoDoc.job.jobNo, 'fileNo': view.cargoDoc.hblNbr2 },
    //   new mx.rpc.Responder(fileCountResultHandler, function (e) { }))
  }
  fileCountResultHandler(result) {
    // if (result.result <= 0)
    //   createFileOnPrintZB()
  }
  /**
   * 生成单证流转在打印正本的时候
   */
  createFileOnPrintZB() {
    // var file: File = File.createFileByJob(view.cargoDoc.job)
    // file.fileType = FileType.HBL_TYPE.code + ''
    // file.fileNo = view.cargoDoc.hblNbr2
    // file.save2(function (e) { }, function (f) { })
  }
  /**
   * 取MBL信息
   */
  async getMBLInfo(type) {
    await new SeaExportJob(this.job).getSeaCargoDoc()
    let mbl = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === CargoDocConsts.MBL) {
        mbl = doc
        break
      }
    }
    if (mbl) {
      if (type === 'mark') {
        this.form.mark = mbl.mark
      } else if (type === 'EName') {
        this.form.cargoEnglishName = mbl.cargoEnglishName
      }
    }
  }
  /**
   * 编辑船名航次模式
   */
  editInputVesselModel() {
    if (this.job) {
      if (this.job.vessel) {
        const curVessel = this.vesselList.filter(p => p.englishName === this.job.vessel)[0]
        if (!curVessel) this.vesselList.push({ englishName: this.job.vessel })
      }
      if (this.job.voyageFlight) {
        const curVoyage = this._voyages.filter(p => p.voyageNo === this.job.voyageFlight)[0]
        if (!curVoyage) {
          this._voyages.push({ voyageNo: this.job.voyageFlight })
        }
      }
    }
    switch (this.editVesselVoyageMode) {
      case 1:
        this._allowEditingVessel = true
        break
      case 2:
        if (this.job && this.job.bookingTerm !== 'OS') {
          this._allowEditingVessel = true
        } else {
          this._allowEditingVessel = false
        }
        break
      case 3:
        this._allowEditingVessel = false
        break
      default:
        break
    }
  }
  /**
   * 是否可编辑件毛体
   */
  controlQwcRoleEdit() {
    // isEditSingleCargoDoc 配置 2 ，被合并HBL可以编辑件毛体，且同步到合并业务
    this.isCanEditQwc = (this.view.isEdit && !this.job.jointMasterHBLUuid) || (this.view.isEdit && this.job.jointMasterHBLUuid && this.isEditSingleCargoDoc === 2)
  }
  /**
   * 编辑控制
   */
  editingChanged() {
    this.lclslaveEnabledChanged()
    this.controlQwcRoleEdit()
  }
  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledChanged() {
    this._lclslaveEnabled = this.view.isEdit && !this.job.lclMasterUuid
  }
  /**
   * 客户自出单
   */
  isCustomerSelfRelease(value) {
    if (value) {
      this.form.customerSelfRelease = 1
    } else if (this.form.customerSelfRelease === 1) {
      this.form.customerSelfRelease = 0
    }
  }
  /**
   * 公司自出单
   */
  isCompanySelfRelease(value) {
    if (value) {
      this.form.customerSelfRelease = 2
    } else if (this.form.customerSelfRelease === 2) {
      this.form.customerSelfRelease = 0
    }
  }
  /**
   * 刷新费用大写和总计
   */
  refershFreightChargeTotal() {
    let totalAmount = 0
    for (const charge of this.view.finalRowData) {
      if (charge.currency === 'USD') { // USD
        totalAmount += charge.amount
      }
    }
    this.form.freightChargeTotal = totalAmount
    this.form.freightChargeEnUpper = StrUtils.jsdx2(totalAmount)
  }
  // refushLoadType() {
  //   if (this.view.isEdit && (this.view.pendTabSize && this.view.pendTabSize > 1)) {
  //     if (this.job.containerLoadType !== 'BB') {
  //       this.form.container = SeaExportUtils.getContainerDesc(this.job, false)
  //     } else {
  //       this.form.container = SeaExportUtils.getContainerDesc(this.job, this.form.printParam3)
  //     }
  //   }
  // }
  async getCfmBillAddressHandler(event = null) {
    if (this.form.cfmState > 1) {
      this.postRemotingTracking('SE-IssueHBL')
    }
    await new SeaExportJob(this.job).getSeaCargoDoc()
    this.reloadCargoDocHandler()
  }
  portChange(p, field) {
    const form = this.form
    form[field + 'Code'] = p.value
    form[field] = p.englishName
  }
  markBlurHandler() {
    if (this.view.action !== 'edit') {
      return
    }
    const seaCargoMark = parseInt(this.config.get('seaCargoMark'))
    if (seaCargoMark === 2) {
      CargoDocUtil.changeBillOfLadingSynDoc(this.form, this.job, ['mark'], true)
    }
  }
  cargoEnglishNameBlurHandler() {
    if (this.view.action !== 'edit') {
      return
    }
    const seaCargoEnglishName = parseInt(this.config.get('seaCargoEnglishName'))
    if (seaCargoEnglishName === 2) {
      CargoDocUtil.changeBillOfLadingSynDoc(this.form, this.job, ['cargoEnglishName'], true)
    }
  }

  /**
   * 提单数据更新
   */
  updateBillInfo(release = false, ifSystemSend = false) {
    const phone = this.view.getContactPhone()
    if (!phone) {
      return
    }
    this.loading = getLoading()
    const params = {
      jobUuid: this.job.uuid,
      docUuid: this.view.form.uuid,
      release: release,
      ifSystemSend: ifSystemSend
    }
    xhqUpdateBillInfo(params).then(res => {
      if (res.data) {
        this.$message.warning(res.data)
      } else {
        this.$message.success(this.view.$t('CargoMsg.Cargo_SendSuccess'))
        if (release) {
          this.view.form.confirmationBillState = CFM_BILL_STATE_UPDATE.code
        } else {
          this.view.form.confirmationBillState = CFM_BILL_STATE_RELEASE.code
        }
      }
    }).finally(() => {
      this.loading.close()
    })
  }
  /**
   * 上传文件
   */
  async toUploadFile(fileCategory, fileCategoryLabel, xhqSendType) {
    if ((fileCategory !== 'SHIPPING_ORDER' && this.view.form.confirmationBillState === CFM_BILL_STATE_NEW.code)) {
      this.$message.warning(this.view.$t('SeaExport.CfmBillFirst'))
      return
    }
    if (fileCategory !== 'SHIPPING_ORDER' && this.view.form.releaseState === ReleaseState.ONSINGLERELEASE.code) {
      this.$message.warning(this.view.$t('SeaExport.IsReleased'))
      return
    }
    if (fileCategory === 'SHIPPING_ORDER' && !(this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_ZDD.code)) {
      this.$message.warning(this.view.$t('SeaExport.UnStartOrUnConfirmCanUpload'))
      return
    }
    const phone = this.view.getContactPhone()
    if (!phone) {
      return
    }
    // 将信号旗的文件类型转换为CARGO的文件类型
    const documentType = await getDocumentTypeByExt({ externalFileType: fileCategory }).then(res => {
      return res.data
    })
    this.view.cloudFile.job.jobNo = this.job.jobNo
    this.view.cloudFile.job.lob = this.job.lob
    this.view.cloudFile.job.mbl = this.job.mbl
    this.view.cloudFile.job.uuid = encodeURIComponent(this.form.uuid)
    this.view.cloudFile.visible = true
    this.view.cloudFile.fileCategory = documentType
    this.view.cloudFile.fileCategoryLabel = fileCategoryLabel
    this.view.cloudFile.uploadSource = 'tblHBL'
    this.view.cloudFile.otherParam.hblNo = this.view.form.hblNbr2
    this.view.cloudFile.otherParam.hblRefNo = this.view.form.hblRefNo
    this.view.cloudFile.otherParam.xhqSendType = xhqSendType // 发送信号旗传的[type]参数，BILL表示提单确认件，OWN_BILL表示客户自出单, SHIPPING_ORDER表示托书文件
  }
  /**
   * 上传文件（通用）
   */
  async toUploadCommonFile(fileCategory, fileCategoryLabel) {
    this.view.cloudFile.job.jobNo = this.job.jobNo
    this.view.cloudFile.job.lob = this.job.lob
    this.view.cloudFile.job.mbl = this.job.mbl
    this.view.cloudFile.job.uuid = encodeURIComponent(this.form.uuid)
    this.view.cloudFile.visible = true
    this.view.cloudFile.fileCategory = fileCategory
    this.view.cloudFile.fileCategoryLabel = fileCategoryLabel
    this.view.cloudFile.uploadSource = 'tblHBL'
    this.view.cloudFile.otherParam.hblNo = this.view.form.hblNbr2
    this.view.cloudFile.otherParam.hblRefNo = this.view.form.hblRefNo
    this.view.cloudFile.otherParam.xhqSendType = ''
  }
  /**
   * 对单中心日志
   */
  async toCheckTheBLLog() {
    this.view.checkTheBLLog.jobUuid = this.form.uuid
    this.view.checkTheBLLog.visible = true
    const logSource = []
    for (const item of SystemConstants.XHQ_INTERFACE) {
      logSource.push(item.code)
    }
    const logSourceStr = logSource.join(',')
    const params = {
      jobUuid: this.job.uuid,
      logSource: logSourceStr
    }
    await xhqQueryCheckTheBLLog(params).then(res => {
      this.view.checkTheBLLog.rowData = res.data
    })
  }

  async toGetXHQCfmAddress(cargoDocUuid) {
    return await xhqGetCfmAddress({ cargoDocUuid }).then(res => res.data)
  }

  toSurrendered() {
    if (this.view.form.releaseState === ReleaseState.ONSINGLERELEASE.code) {
      this.$message.warning(this.view.$t('SeaExport.IsReleased2'))
      return
    }
    if (this.view.form.cfmState !== CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
      this.$message.warning(this.view.$t('SeaExport.BillNotCfm'))
      return
    }
    if (this.view.form.releaseState !== ReleaseState.SINGLERELEASE.code && this.view.IfXHQReleaseRequireHBLReleaseReview === 1) {
      this.$message.warning(this.view.$t('SeaExport.BillNotRelease'))
      return
    }
    if (!this.view.job.atd) {
      this.$message.warning(this.view.$t('SeaExport.ATDIsNull'))
      return
    }
    if (!(this.view.form.releaseType === BillReleaseType.SURRENDERED.code)) {
      this.$message.warning(this.view.$t('SeaExport.OnlySurrenderedSupport'))
      return
    }
    this.updateBillInfo(true)
  }

  btnRequestReleasingClickHandler() {
    const { requestReleaseState, uuid } = this.view.form
    const uuids = [uuid]
    if (requestReleaseState === 0) {
      this.loading = getLoading()
      requestRelease(uuids).then(async res => {
        this.loading.close()
        this.view.form.requestReleaseState = 1
        await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
        this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(Number(res.data[uuid].releaseState))
        this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
      }).catch(() => {
        this.loading.close()
      })
      return
    }
    this.loading = getLoading()
    cancelRequestRelease(uuids).then(async res => {
      this.loading.close()
      this.view.form.requestReleaseState = 0
      await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
      this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    }).catch(() => {
      this.loading.close()
    })
  }
}
